"use strict";

var cx = require("classnames");

var GoogleCalendarDescription = React.createClass({
  mixins: [ReactIntl.IntlMixin],

  render: function() {
    var intlPrefixPath = "integration.google_calendar.";

    var syncActivities = this.getIntlMessage(intlPrefixPath + "sync_activities");
    var typeConfiguration = this.getIntlMessage(intlPrefixPath + "type_configuration");
    var customNotification = this.getIntlMessage(intlPrefixPath + "custom_notification");
    var activeIntegration = this.getIntlMessage(intlPrefixPath + "active_integration");

    return (
      <ul>
        <h6 className="pb-5">{activeIntegration}</h6>
        <li className="integrationsDescription-item">{syncActivities}</li>
        <li className="integrationsDescription-item">{typeConfiguration}</li>
        <li className="integrationsDescription-item">{customNotification}</li>
      </ul>
    );
  }
});

module.exports = GoogleCalendarDescription;



// WEBPACK FOOTER //
// ./app/screens/Integration/components/GoogleCalendar/google-calendar-description.jsx